import React from "react";
import { FormStore } from "../formx";

export type FormContextType = {
  store: FormStore<any>;
};

export const FormContext = React.createContext<FormContextType>({ store: null });
